export default {
    init() {
        var gallery_container = $('.gallery-slider');
        if (gallery_container.find('.padder > a').length) {
            var prevArrow = $('<button />').addClass('product-prev').html('Previous');
            var nextArrow = $('<button />').addClass('product-next').html('Next');
            var gallery = gallery_container.find('.padder');
            gallery.slick({
                appendDots: gallery_container,
                dots: false,
                infinite: true,
                nextArrow: nextArrow,
                prevArrow: prevArrow,
                slidesToShow: 4,
                slidesToScroll: 4,
                responsive: [
                    {
                        breakpoint: 950,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        },
                    },
                    {
                        breakpoint: 700,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        },
                    },
                    {
                        breakpoint: 450,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                ],
            });

            gallery_container.append(prevArrow).append(nextArrow);

            gallery.magnificPopup({
                delegate: 'a.slick-slide:not(.slick-cloned)', // the selector for gallery item
                type: 'image',
                image: {
                    titleSrc: function (item) {
                        return item.el.find('img').data('description');
                    },
                },
                gallery: {
                    enabled: true,
                },
            });

            var tables = $('.table');
            tables.each(function(key, relem){
                relem.offsetLeft;
                $(relem).find('img').offsetLeft;
            });
        }
    },
    finalize() {
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js